'use strict';

require('./TextFieldSuggestedListItem.scss');

const React = require('react'),
    get = require('lodash/object').get,
    {PropTypes} = require('react');

const TextFieldSuggestedListItem = React.createClass({displayName: "TextFieldSuggestedListItem",

    propTypes: {
        item: PropTypes.object,
        isDisabled: PropTypes.bool,
        readerAttribute: PropTypes.readerAttribute,
        onClick: PropTypes.func,
        matchText: PropTypes.string
    },

    onKeyDown(evt) {
        const {onClick, item} = this.props;
        const isKeyPressEnter = evt.keyCode === 13;
        const isKeyPressSpace = evt.keyCode === 32;
        const isKeyPressScape = evt.keyCode === 27;

        if (isKeyPressEnter || isKeyPressSpace || isKeyPressScape) {
            onClick(item);
        }
    },

    getTextItem(item, matchText, readerAttribute) {
        const haveMatchText = !!matchText;
        const text = get(item, readerAttribute);

        if (haveMatchText) {
            return (
                React.createElement("span", null, 
                    getTextHeightLighted(text, matchText)
                )
            );
        } else {
            return (
                React.createElement("span", null, 
                    text
                )
            );
        }
    },

    render() {
        const {item, readerAttribute, onClick, isDisabled, matchText} = this.props;
        const textEl = this.getTextItem(item, matchText, readerAttribute, isDisabled);
        return (
            React.createElement("li", {
                onKeyDown: isDisabled ? null : this.onKeyDown, 
                tabIndex: "0", 
                onClick: isDisabled ? null : onClick.bind(this, item), 
                className: 'bp-textfield-suggested-list-item' + (isDisabled ? ' is-disabled' : '')
            }, 
                textEl
            )
        );
    }
});

function getTextHeightLighted(text, matchText) {
    const safeText = text || '';
    const textNotKeySensitive = safeText.toLowerCase();
    const matchTextNotKeySensitive = matchText.toLowerCase();

    const indexStartingMatch = textNotKeySensitive.indexOf(matchTextNotKeySensitive);
    const matchingTextLength = matchText.length;
    const indexEndMatching = indexStartingMatch + matchingTextLength;
    const lengthText = safeText.length;

    const firstTextWithoutHeightLight = safeText.substring(0, indexStartingMatch);
    const textWithoutHeightLight = safeText.substring(indexStartingMatch, indexEndMatching);
    const lastTextWithoutHeightLight = safeText.substring(indexEndMatching, lengthText);

    return (
        React.createElement("span", null, 
            React.createElement("span", null, 
                firstTextWithoutHeightLight
            ), 
            React.createElement("span", {className: "is-matching"}, 
                textWithoutHeightLight
            ), 
            React.createElement("span", null, 
                lastTextWithoutHeightLight
            )
       )
    );
}

module.exports = TextFieldSuggestedListItem;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/TextField/TextFieldSuggested/TextFieldSuggestedList/TextFieldSuggestedListItem.jsx
 **/